<template>
    <span id="counsellor-edit">
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-action btn-success btn-sm mr-2 mb-2" data-toggle="modal"
            :data-target="getDataTarget()" @click="resetForm()"><i class="fas fa-edit"></i></button>

        <!-- Modal -->
        <div class="modal fade text-left" :id="getModalId()" tabindex="-1" aria-labelledby="counsellorEditLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="counsellorEditLabel">Edit Counsellor</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="alert.status" :class="getAlertClass()" role="alert">
                            <i :class="getAlertIcon()"></i> {{ alert.message }}
                        </div>
                        <form :id="getFormId()" @submit.prevent>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="givenName">First Name</label>
                                        <input type="text" class="form-control form-control-sm" disabled id="givenName"
                                            name="givenName" v-model="counsellor.givenName" aria-describedby="givenName"
                                            placeholder="Not available">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="surname">Last Name</label>
                                        <input type="text" class="form-control form-control-sm" disabled id="surname"
                                            name="surname" v-model="counsellor.surname" aria-describedby="surname"
                                            placeholder="Not available">
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="role">Role</label>
                                        <input type="text" class="form-control form-control-sm" disabled id="role"
                                            name="role" v-model="counsellor.role" aria-describedby="role"
                                            placeholder="Not available">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="office">Office</label>
                                        <input type="text" class="form-control form-control-sm" id="office"
                                            name="office" v-model="office" aria-describedby="office"
                                            placeholder="Please provide an office">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <label for="waitingArea">Waiting Area</label>
                                    <select class="form-control form-control-sm" id="waitingArea" name="waitingArea"
                                        v-model="waitingArea">
                                        <option value="">Not Assigned</option>
                                        <option v-for="(waitingArea, i) in waitingAreas" :key="i"
                                            :value="waitingArea.value"> {{ waitingArea.label }}</option>
                                    </select>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="zoomLink">Zoom Link</label>
                                        <input type="text" class="form-control form-control-sm" id="zoomLink"
                                            name="zoomLink" v-model="zoomLink" aria-describedby="zoomLink"
                                            placeholder="Please provide a zoom link">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button v-if="loading" disabled type="button" class="btn btn-primary">Saving <i
                                class="fas fa-spinner fa-spin"></i></button>
                        <button v-else type="button" class="btn btn-primary" @click="editCounsellor()">Save</button>
                        <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    name: 'counsellors-edit',
    props: {
        counsellor: {
            required: true,
            type: Object
        },
        waitingAreas: {
            required: true,
            type: Array
        }
    },
    data() {
        return {
            alert: {
                message: '',
                status: false,
                type: ''
            },
            loading: false,
            office: '',
            waitingArea: '',
            zoomLink: ''
        }
    },
    methods: {
        editCounsellor() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?setCounsellorsData`;
            const formData = new FormData();

            // Set loading
            this.alert.status = false;
            this.loading = true;

            // Add form keypair values
            formData.append('data', JSON.stringify({
                // commonName: `${this.counsellor.sn}, ${this.counsellor.givenName}`,
                // givenName: this.counsellor.givenName,
                id: this.counsellor.id,
                office: this.office,
                // role: this.counsellor.title,
                // surname: this.counsellor.sn,
                // username: this.counsellor.sAMAccountName,
                waitingArea: this.waitingArea,
                zoomLink: this.zoomLink
            }));
            formData.append('mode', 'setCounsellorsData');

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Update system settings
                if (json.result.match(/OK/i)) {
                    that.alert.message = `${that.counsellor.givenName} ${that.counsellor.surname}'s counsellor information has been saved.`;
                    that.alert.type = "success";
                } else if (json.result.match(/WARNING/i)) {
                    // Other error
                    that.alert.message = `${that.counsellor.givenName} ${that.counsellor.surname}'s counsellor information could not be saved. ${json.message}`;
                    that.alert.type = "warning";
                } else {
                    // Internal error
                    that.alert.message = `${that.counsellor.givenName} ${that.counsellor.surname}'s counsellor information could not be saved. An error has occurred. Please contact your system administrator.`;
                    that.alert.type = "danger";
                }

                that.refreshData();
                that.alert.status = true;
                that.loading = false;
            }).catch(function () {
                // Internal error
                that.alert.message = `${that.counsellor.givenName} ${that.counsellor.surname}'s counsellor information could not be saved. An error has occurred. Please contact your system administrator.`;
                that.alert.type = "danger";
                that.alert.status = true;
                that.loading = false;
            })
        },
        getAlertClass() {
            if (this.alert.type == "success") {
                return `alert alert-success`;
            } else if (this.alert.type == "warning") {
                return `alert alert-warning`;
            } else if (this.alert.type == "danger") {
                return `alert alert-danger`;
            }

            return `alert alert-primary`;
        },
        getAlertIcon() {
            if (this.alert.type == "success") {
                return `fas fa-check`;
            } else if (this.alert.type == "warning") {
                return `fas fa-exclamation-circle`;
            } else if (this.alert.type == "danger") {
                return `fas fa-exclamation-triangle`;
            }

            return `fas fa-bell`;
        },
        getDataTarget() {
            return `#counsellorEdit-${this.counsellor.id}`;
        },
        getFormId() {
            return `counsellorEditForm-${this.counsellor.id}`;
        },
        getModalId() {
            return `counsellorEdit-${this.counsellor.id}`;
        },
        refreshData() {
            this.$emit('refreshData');
        },
        resetForm() {
            this.alert = {
                    message: '',
                    status: false,
                    type: ''
                };
            this.office = this.counsellor.office || '';
            this.waitingArea = this.counsellor.waitingArea || '';
            this.zoomLink = this.counsellor.zoomLink || '';
        }
    }
}
</script>